import { PrebuiltPC } from '@/types/types';


export const prebuiltSystems: PrebuiltPC[] = [
  {
    id: "1",
    name: "Vortex Prime",
    category: "Gaming PC",
    price: 2499,
    originalPrice: 2699,
    discount: 200,
    bestseller: true,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//apex_predator.avif",
    // Canonical IDs for logic (update these to match your component data)
    cpuId: "cpu-11", // Ryzen 7 9700X (example, update as needed)
    gpuId: "gpu-4", // NVIDIA RTX 5070 TI (example, update as needed)
    ramId: undefined, // Update when RAM IDs are canonical
    storageId: undefined, // Update when storage IDs are canonical
    coolingId: undefined,
    psuId: undefined,
    // Display fields for UIYes
    cpuDisplay: "Ryzen 7 9700X",
    gpuDisplay: "NVIDIA RTX 5070TI 16GB",
    ramDisplay: "32GB DDR5 6000MHZ",
    storageDisplay: "2TB NVMe SSD",
    coolingDisplay: "360mm LCD AIO Liquid Cooler",
    psuDisplay: "850W 80+ Gold",
    // Legacy fields (deprecated)
    seoDescription: "The Vortex Prime is a top-tier gaming PC built for enthusiasts who demand maximum performance. Featuring the powerful Ryzen 7 9700X CPU and NVIDIA RTX 5070TI 16GB GPU, this system delivers ultra-smooth gameplay and high frame rates in the latest AAA titles. With 32GB DDR5 RAM and a 2TB NVMe SSD, you get lightning-fast load times and seamless multitasking. Enjoy premium quality, expert assembly, free shipping, and a 3-year warranty from BattleforgePC.",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 178 },
      { game: "Call of Duty: Warzone", fps: 260 },
      { game: "Fortnite", fps: 260 }
    ]
  },
  {
    id: "2",
    name: "Shadowstrike RX",
    category: "Gaming PC",
    price: 1899,
    originalPrice: 1899,
    discount: 0,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//maxresdefault.avif",
    cpuId: "cpu-8", // AMD Ryzen 7 7800X3D
    gpuId: "gpu-3", // NVIDIA RTX 5070 12GB
    ramId: "ram-2-32gb", // 32GB DDR5 5200MHz (example)
    storageId: "storage-1", // 1TB NVMe SSD (example)
    coolingId: "cooler-1", // 240mm AIO Liquid Cooler (example)
    psuId: "psu-1", // 750W 80+ Gold (example, may need to adjust)
    cpuDisplay: "AMD Ryzen 7 7800X3D",
    gpuDisplay: "NVIDIA RTX 5070 12GB",
    ramDisplay: "32GB DDR5 5200MHz",
    storageDisplay: "1TB NVMe SSD",
    coolingDisplay: "240mm AIO Liquid Cooler",
    psuDisplay: "750W 80+ Gold",
    seoDescription: "Shadowstrike RX is engineered for gamers who want reliable high FPS and smooth streaming. Powered by an AMD Ryzen 7 7800X3D and NVIDIA RTX 5070 12GB, this PC is perfect for competitive gaming and content creation. 32GB DDR5 RAM and a 1TB NVMe SSD ensure fast performance and ample storage. Built by BattleforgePC with free shipping and a 3-year warranty.",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 95 },
      { game: "Call of Duty: Warzone", fps: 144 },
      { game: "Fortnite", fps: 200 }
    ]
  },
  {
    id: "3",
    name: "Stream Master",
    category: "Streaming PC",
    price: 2199,
    originalPrice: 2399,
    discount: 200,
    bestseller: true,
    imageUrl: "https://images.unsplash.com/photo-1624705013726-8cb4f9415f48?q=80&w=2680&auto=format",
    cpuId: "cpu-10", // AMD Ryzen 7 7700X
    gpuId: "gpu-5", // NVIDIA RTX 5070 16GB (example)
    ramId: "ram-2-32gb", // 32GB DDR5 5200MHz
    storageId: "storage-2", // 2TB NVMe SSD
    coolingId: "cooler-2", // 360mm AIO Liquid Cooler (example)
    psuId: "psu-2", // 850W 80+ Gold
    cpuDisplay: "AMD Ryzen 9 7700X",
    gpuDisplay: "NVIDIA RTX 5070 16GB",
    ramDisplay: "32GB DDR5 5200MHz",
    storageDisplay: "2TB NVMe SSD",
    coolingDisplay: "360mm AIO Liquid Cooler",
    psuDisplay: "850W 80+ Gold",
    seoDescription: "The Stream Master is the ultimate PC for streamers and creators. With an AMD Ryzen 9 7700X and NVIDIA RTX 5070 16GB, you can game and stream simultaneously with zero compromise. 32GB DDR5 RAM and 2TB NVMe SSD provide fast multitasking and storage for all your content. Enjoy expert assembly, free shipping, and a 3-year warranty from BattleforgePC.",
    benchmarks: [
      { game: "Cyberpunk 2077 (While Streaming)", fps: 90 },
      { game: "Call of Duty: Warzone (While Streaming)", fps: 120 },
      { game: "Fortnite (While Streaming)", fps: 180 }
    ]
  },
  {
    id: "4",
    name: "Creator Pro",
    category: "Workstation",
    price: 4999,
    originalPrice: 4999,
    discount: 0,
    bestseller: false,
    imageUrl: "https://images.unsplash.com/photo-1591405351990-4726e331f141?q=80&w=2670&auto=format",
    cpuId: "cpu-12", // Ryzen 7 9800X3D (example, update as needed)
    gpuId: undefined, // NVIDIA RTX 5090 36GB (not in mock data)
    ramId: undefined, // 96GB DDR5 6200MHZ (not in mock data, closest: ram-4-64gb)
    storageId: "storage-1", // 1TB NVMe SSD (example, doesn't handle multi-drive)
    coolingId: undefined, // TRYX Panorama AIO (not in mock data)
    psuId: "psu-3", // 1000W 80+ Platinum (closest: psu-3 1000W Gold)
    cpuDisplay: "Ryzen 7 9800X3D",
    gpuDisplay: "NVIDIA RTX 5090 36GB",
    ramDisplay: "96GB DDR5 6200MHZ",
    storageDisplay: "1TB NVMe SSD + 4TB NVME SSD",
    coolingDisplay: "TRYX Panorama AIO",
    psuDisplay: "1000W 80+ Platinum",
    seoDescription: "",
    benchmarks: [
      { game: "DaVinci Resolve Export (4K)", fps: 120 },
      { game: "Blender Rendering", fps: 100 },
      { game: "Adobe Premiere Pro 4K Export", fps: 120 }
    ]
  },
  {
    id: "5",
    name: "Crimson Core Mini",
    category: "Gaming PC",
    price: 1399,
    originalPrice: 1499,
    discount: 100,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//OIP-_2_.avif",
    cpuId: "cpu-6", // AMD Ryzen 5 7600X
    gpuId: "gpu-1", // NVIDIA RTX 5060 Ti 8GB (closest: 5060TI - 8GB)
    ramId: "ram-2-32gb", // 32GB DDR5 5200MHz
    storageId: "storage-2", // 2TB NVMe SSD
    coolingId: undefined, // Air Cooler (not in mock data)
    psuId: undefined, // 650W 80+ Bronze (not in mock data)
    cpuDisplay: "AMD Ryzen 5 7600X",
    gpuDisplay: "NVIDIA RTX 5060 Ti 8GB",
    ramDisplay: "32Gb DDR5 5200MHz",
    storageDisplay: "2TB NVMe SSD",
    coolingDisplay: "Air Cooler",
    psuDisplay: "750W 80+ Gold",
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 80 },
      { game: "Call of Duty: Warzone", fps: 160 },
      { game: "Fortnite", fps: 215 }
    ]
  },
  {
    id: "6",
    name: "BattleforgePC Studio",
    category: "Workstation",
    price: 3200,
    originalPrice: 3200,
    discount: 0,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//s-l960.avif",
    cpuId: undefined, // AMD Ryzen 9 9900X (not in mock data)
    gpuId: undefined, // NVIDIA RTX 5080 16GB (not in mock data)
    ramId: "ram-4-64gb", // 64GB DDR5 5600MHz (example)
    storageId: "storage-2", // 2TB NVMe SSD (doesn't handle multi-drive)
    coolingId: undefined, // 280mm AIO Liquid Cooler (not in mock data)
    psuId: "psu-3", // 1000W 80+ Gold
    cpuDisplay: "AMD Ryzen 9 9900X",
    gpuDisplay: "NVIDIA RTX 5080 16GB",
    ramDisplay: "64GB 2*32GB DDR5 5600MHz",
    storageDisplay: "2TB NVMe SSD + 4TB HDD",
    coolingDisplay: "280mm AIO Liquid Cooler",
    psuDisplay: "1000W 80+ Gold",
    seoDescription: "",
    benchmarks: [
      { game: "Adobe After Effects", fps: 120 },
      { game: "3D Rendering", fps: 100 },
      { game: "4K Video Editing", fps: 90 }
    ]
  },
  {
    id: "7",
    name: "Ironclad One",
    category: "Gaming PC",
    price: 750,
    originalPrice: 750,
    discount: 0,
    bestseller: true,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//5.avif",
    cpuId: "cpu-4", // AMD Ryzen 5 5500
    gpuId: undefined, // NVIDIA RTX 6600 8GB (not in mock data)
    ramId: "ram-1", // 16GB DDR4 3200MHz (example)
    storageId: "storage-1", // 1TB NVMe SSD
    coolingId: "stock-cooler", // Stock Cooler
    psuId: undefined, // 550W 80+ Bronze (not in mock data)
    cpuDisplay: "AMD Ryzen 5 5500",
    gpuDisplay: "NVIDIA RTX 6600 8GB",
    ramDisplay: "16GB DDR4 3200MHz",
    storageDisplay: "1TB NVMe SSD",
    coolingDisplay: "Stock Cooler",
    psuDisplay: "550W 80+ Bronze",
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 65 },
      { game: "Call of Duty: Warzone", fps: 130 },
      { game: "Fortnite", fps: 160 }
    ]
  },
  {
    id: "8",
    name: "Stream Starter",
    category: "Streaming PC",
    price: 1599,
    originalPrice: 1699,
    discount: 100,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//2.avif",
    cpuId: "cpu-10", // AMD Ryzen 7 7700X
    gpuId: "gpu-1", // NVIDIA RTX 5060 Ti 8GB (closest)
    ramId: "ram-2-32gb", // 32GB DDR5 5200MHz
    storageId: "storage-1", // 1TB NVMe SSD
    coolingId: "cooler-1", // 240mm AIO Liquid Cooler
    psuId: undefined, // 650W 80+ Gold (not in mock data)
    cpuDisplay: "AMD Ryzen 7 7700X",
    gpuDisplay: "NVIDIA RTX 5060 Ti 8GB",
    ramDisplay: "32GB DDR5 5200MHz",
    storageDisplay: "1TB NVMe SSD",
    coolingDisplay: "240mm AIO Liquid Cooler",
    psuDisplay: "650W 80+ Gold",
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077 (While Streaming)", fps: 70 },
      { game: "Call of Duty: Warzone (While Streaming)", fps: 100 },
      { game: "Fortnite (While Streaming)", fps: 150 }
    ]
  },
  {
    id: "9",
    name: "Spectrum Overdrive One",
    category: "Gaming PC",
    price: 6000,
    originalPrice: 6500,
    discount: 500,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//IMG_3184.png",
    cpuId: "cpu-12", // Ryzen 7 9800X3D (example, update as needed)
    gpuId: undefined, // NVIDIA RTX 5080 (not in mock data)
    ramId: "ram-3-32gb", // 32GB DDR5 6000MHz RGB (example)
    storageId: "storage-2", // 2TB NVMe SSD
    coolingId: undefined, // 360mm LCD RGB AIO (not in mock data)
    psuId: "psu-3", // 1000W 80+ Gold
    cpuDisplay: "Ryzen 7 9800X3D",
    gpuDisplay: "NVIDIA RTX 5090",
    ramDisplay: "32GB DDR5 6000MHz RGB",
    storageDisplay: "2TB NVMe SSD",
    coolingDisplay: "360mm Liquid Hardlined CPU/GPU",
    psuDisplay: "1000W 80+ Gold",
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 200 },
      { game: "Call of Duty: Warzone", fps: 360 },
      { game: "Fortnite", fps: 360 }
    ]
  },
  {
    id: "10",
    name: "Nova Pulse",
    category: "Gaming PC",
    price: 1400,
    originalPrice: 1400,
    discount: 0,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//7.avif",
    cpuId: "cpu-5", // Ryzen 5 7600
    gpuId: undefined, // NVIDIA RTX 5060 (not in mock data)
    ramId: "ram-3-32gb", // 32GB DDR5 6000MHz RGB (example)
    storageId: "storage-1", // 1TB NVMe SSD
    coolingId: undefined, // 240MM RGB AIO (not in mock data)
    psuId: "psu-1", // 750W 80+ Gold
    cpuDisplay: "Ryzen 5 7600",
    gpuDisplay: "NVIDIA RTX 5060",
    ramDisplay: "32GB DDR5 6000MHz RGB",
    storageDisplay: "1TB NVMe SSD",
    coolingDisplay: "240MM RGB AIO",
    psuDisplay: "750W 80+ Gold",
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 200 },
      { game: "Call of Duty: Warzone", fps: 360 },
      { game: "Fortnite", fps: 360 }
    ]
  },  
 {
    id: "11",
    name: "Ironclad Lite",
    category: "Gaming PC",
    price: 630,
    originalPrice: 550,
    discount: 0,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//5.avif",
    cpuId: "cpu-7",
    gpuId: "gpu-10",
    ramId: "ram-1-16gb",
    storageId: "storage-1",
    motherboardId: "mobo-6",
    caseId: "case-6",
    coolingId: "stock-cooler",
    psuId: "psu-7",
    cpuDisplay: "AMD Ryzen 5 5500 - USED",
    gpuDisplay: "RTX 3060",
    ramDisplay: "16GB DDR4 3200MHz",
    storageDisplay: "1TB NVMe SSD",
    coolingDisplay: "Stock Cooler",
    psuDisplay: "550W 80+ Bronze",
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 65 },
      { game: "Call of Duty: Warzone", fps: 130 },
      { game: "Fortnite", fps: 160 }
    ]
  },
  {
    id: "12",
    name: "ForgeLite - USED PARTS",
    category: "Gaming PC",
    price: 350,
    originalPrice: 500,
    discount: 75,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//61xz4i4bSzL._AC_SL1500_.avif",
    cpuId: undefined, // AMD Ryzen 5 5500
    gpuId: undefined, // NVIDIA RTX 580 8GB (not in mock data)
    ramId: "ram-1-16gb", // 16GB DDR4 3200MHz (example)
    storageId: "storage-1", // 1TB NVMe SSD
    coolingId: "stock-cooler", // Stock Cooler
    psuId: undefined, // 550W 80+ Bronze (not in mock data)
    cpuDisplay: "Ryzen 5 3600 - USED",
    gpuDisplay: "GTX 1080 - USED",
    ramDisplay: "16GB DDR4 3200MHZ",
    storageDisplay: "500GB NVMe SSD + 1TB HDD",
    coolingDisplay: "Stock Cooler",
    psuDisplay: "600W 80+ Bronze", 
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 65 },
      { game: "Call of Duty: Warzone", fps: 130 },
      { game: "Fortnite", fps: 160 }
    ]
  },
  {
    id: "13",
    name: "Ironclad Core - USED PARTS",
    category: "Gaming PC",
    price: 450,
    originalPrice: 450,
    discount: 0,
    bestseller: false,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//5.avif",
    cpuId: undefined, // AMD Ryzen 5 5500
    gpuId: undefined, // NVIDIA RTX 580 8GB (not in mock data)
    ramId: "ram-1-16gb", // 16GB DDR4 3200MHz (example)
    storageId: "storage-1", // 1TB NVMe SSD
    coolingId: "stock-cooler", // Stock Cooler
    psuId: undefined, // 550W 80+ Bronze (not in mock data)
    cpuDisplay: "Ryzen 5 5500 - USED",
    gpuDisplay: "RTX 2070 SUPER - USED",
    ramDisplay: "16GB DDR4 3200MHZ",
    storageDisplay: "500GB NVMe SSD + 1TB HDD",
    coolingDisplay: "Stock Cooler",
    psuDisplay: "650W 80+ Bronze", 
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 65 },
      { game: "Call of Duty: Warzone", fps: 130 },
      { game: "Fortnite", fps: 160 }
    ]
  },
  {
    id: "14",
    name: "Spectrum Overdrive Core" ,
    category: "Gaming PC",
    price: 5000,
    originalPrice: 5500,
    discount: 500,
    bestseller: true,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//maxresdefault-_1_.avif",
    cpuId: "cpu-12", // Ryzen 7 9800X3D (example, update as needed)
    gpuId: undefined, // NVIDIA RTX 5080 (not in mock data)
    ramId: "ram-3-32gb", // 32GB DDR5 6000MHz RGB (example)
    storageId: "storage-2", // 2TB NVMe SSD
    coolingId: undefined, // 360mm LCD RGB AIO (not in mock data)
    psuId: "psu-3", // 1000W 80+ Gold
    cpuDisplay: "Ryzen 7 9800X3D",
    gpuDisplay: "NVIDIA RTX 5080",
    ramDisplay: "32GB DDR5 6000MHz RGB",
    storageDisplay: "2TB NVMe SSD",
    coolingDisplay: "360mm Liquid Hardlined CPU/GPU",
    psuDisplay: "1000W 80+ Gold",
    seoDescription: "",
    benchmarks: [
      { game: "Cyberpunk 2077", fps: 200 },
      { game: "Call of Duty: Warzone", fps: 360 },
      { game: "Fortnite", fps: 360 }
    ]
  },
  {
    id: "15",
    name: "Nebula Prime",
    category: "Gaming PC",
    price: 3200,
    originalPrice: 3500,
    discount: 300,
    bestseller: true,
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//background-replacer-result.avif",
    cpuId: "cpu-9", // Ryzen 7 9800X3D (example, update as needed)
    gpuId: "gpu-4", // NVIDIA RTX 5080 (not in mock data)
    ramId: "ram-3-32gb", // 32GB DDR5 6000MHz RGB (example)
    storageId: "storage-2", // 2TB NVMe SSD
    coolingId: undefined, // 360mm LCD RGB AIO (not in mock data)
    psuId: "psu-3", // 1000W 80+ Gold
    cpuDisplay: "Ryzen 7 9800X3D",
    gpuDisplay: "NVIDIA RTX 5070 TI",
    ramDisplay: "32GB DDR5 6000MHz RGB",
    storageDisplay: "2TB NVMe SSD",
    coolingDisplay: "360mm TRYX Panorama AIO",
    psuDisplay: "1000W 80+ Gold",
    seoDescription: "",
  } 



];
